import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
`;

export const ContainerWithBorder = styled.div<{ isBenefitListPresent: boolean }>`
    flex: 1;
    border-bottom: ${props => (props.isBenefitListPresent ? "1px" : "0")} dashed
        ${props => props.theme.colors[props.theme.colorMode].background_Secondary};
`;

export const HeaderContainer = styled.div`
    margin-bottom: ${props => props.theme.spacing.small};
`;

export const HeaderIconImageContainer = styled.div<{ height: string; width: string }>`
    display: inline-block;
    margin-right: ${props => props.theme.spacing.xxSmall};
    width: ${props => props.width};
    height: ${props => props.height};
    vertical-align: middle;

    // To align the image with the text for android seeing an issue with vertical-align: middle in android
    // .an class is globally added to the html tag in android
    .an & {
        vertical-align: text-bottom;
    }
`;

export const HeaderText = styled(Text)<{ isOneLitePlan: boolean }>`
    display: inline;
    color: ${props =>
        props.isOneLitePlan
            ? props.theme.colors[props.theme.colorMode].swiggy_One
            : props.theme.colors[props.theme.colorMode].text_High_Emphasis};
    vertical-align: middle;
`;

export const DeliveryTagInfoContainer = styled.div`
    width: 84px;
`;
